// @flow
import { omit } from 'lodash';

import { EDITORIAL_FOLDING_BLOCK } from 'Client/cms/toolkit/constants';
import { props } from './collapsePanel.resolver';

export const editorialFoldingBlockResolver = {
  name: EDITORIAL_FOLDING_BLOCK,
  props() {
    return {
      ...omit(props(), ['children']),
      componentId: ({ anchor }) => anchor,
    };
  },
};
